import { hydrateRoot } from "react-dom/client";
import { PublicNotFound } from "@/components/public-not-found";
import { AppShell } from "./app-shell";
import { getMessagesForLocale, setClientI18nContext } from "./i18n-runtime";
import { resolveLocaleAndPath, resolvePage } from "./routes";
import { hydrateRuntimePageData } from "./runtime-page-data";

function hydrateServerRuntimeData() {
  const element = document.getElementById("__sendbot-runtime-data");
  if (!element?.textContent) {
    hydrateRuntimePageData({});
    return;
  }

  try {
    hydrateRuntimePageData(JSON.parse(element.textContent));
  } catch (error) {
    hydrateRuntimePageData({});
    console.error("[landing] Invalid server runtime data", error);
  }
}

async function bootstrap() {
  const root = document.getElementById("root");
  if (!root) throw new Error("Landing root element was not found");

  hydrateServerRuntimeData();

  const { locale } = resolveLocaleAndPath(window.location.pathname);
  const messages = await getMessagesForLocale(locale);
  const nonce = document.querySelector<HTMLMetaElement>(
    'meta[name="csp-nonce"]',
  )?.content;
  setClientI18nContext({ locale, messages });
  const page = await resolvePage(window.location.href);
  if (!page) {
    hydrateRoot(
      root,
      <AppShell locale={locale} messages={messages} nonce={nonce}>
        <PublicNotFound />
      </AppShell>,
    );
    return;
  }

  hydrateRoot(
    root,
    <AppShell locale={locale} messages={messages} nonce={nonce}>
      {page.element}
    </AppShell>,
  );
}

void bootstrap();
